import Axios from "axios";
import {
    SET_INV_DELIVERY_REPORTS_LIST, 
    UNSET_INV_DELIVERY_REPORTS_LIST
} from "@/store/mutation-types";
import {
    getDeliveryReports,
} from "@/store/api";

const state = {
    getDeliveryReports: [],
};

const getters = {
    getDeliveryReports(state) {
        return state.getDeliveryReports;
    },
};

const mutations = {
    [SET_INV_DELIVERY_REPORTS_LIST](state, data) {
        state.getDeliveryReports = data;
    },
    [UNSET_INV_DELIVERY_REPORTS_LIST](state) {
        state.getDeliveryReports = [];
    },
};

const actions = {

    getDeliveryReports({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`${getDeliveryReports}`, { params: data })
                .then((response) => {
                    commit(SET_INV_DELIVERY_REPORTS_LIST, response.data.data );
                    resolve(response);
                })
                .catch((error) => {
                    commit(UNSET_INV_DELIVERY_REPORTS_LIST);
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
    

};


export default {
    state,
    getters,
    actions,
    mutations,
};